/** Parola gücü göstergesi: parola değiştirme ve bağlantıyla parola belirleme ekranları ortak kullanır. */
export const STRENGTH = [
  { label: 'Çok zayıf', color: '#c4271d' },
  { label: 'Zayıf', color: '#c4271d' },
  { label: 'Orta', color: '#d97706' },
  { label: 'İyi', color: '#7fb21f' },
  { label: 'Güçlü', color: '#1f9d55' },
]

/** Kaba bir güç tahmini (0–4): uzunluk, büyük/küçük harf, rakam, sembol ya da çok uzunluk. */
export function strength(pw: string) {
  let s = 0
  if (pw.length >= 10) s++
  if (/[A-ZÇĞİÖŞÜ]/.test(pw) && /[a-zçğıöşü]/.test(pw)) s++
  if (/[0-9]/.test(pw)) s++
  if (/[^A-Za-z0-9çğıöşüÇĞİÖŞÜ]/.test(pw) || pw.length >= 16) s++
  return s
}
